<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{translations('navbar.sale_management')}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{translations('deposit.archive_deposit')}}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-4 justify-content-between">
        <div class="d-flex flex-wrap align-items-center">
          <div class="form-group mr-2">
            <button class="btn btn-primary" type="button" data-toggle="modal" data-target="#ArchivePaymentsModal">{{translations('common.addition')}}</button>
          </div>
          <div class="form-group mr-1">
            <input id='dtSearch' type="text" class="form-control" v-model='dtSearch' :placeholder="translations('common.keyword_search')">
          </div>
          <div class="form-group mr-3">
            <v-select
              :value="master_clients.find(m => m.id === client_id) || ''"
              :options="master_clients"
              label="name"
              :placeholder="translations('invoice.supplier')"
              :id="client_id"
              @input="changedClients">
            </v-select>
          </div>
          <div class="form-group mr-3 d-flex flex-wrap">
            <span class="mr-1">{{ translations('common.period') }}</span>
            <!--          <input v-model="dateFrom" type="date" class="form-control" @blur='triggerDateFilter("dateFrom")' @focus='tempDateField = dateFrom;'>-->
            <input v-model="dateFrom" type="date" class="form-control">
            <span class="mr-1 ml-1">〜</span>
            <!--          <input v-model="dateTo" type="date" class="form-control" @blur='triggerDateFilter("dateTo")' @focus='tempDateField = dateTo'>-->
            <input v-model="dateTo" type="date" class="form-control">
          </div>
          <div class="form-group">
            <button class="btn btn-sm btn-link p-0 decoration-underline" type="button" data-toggle="modal" data-target="#ArchiveBulkPaymentsModal">{{translations('deposit.lump_sum_deposit')}}</button>
          </div>
          <div class="form-group ml-2">
            <div class="form-check">
              <input v-model="displayAll" class="form-check-input pointer-clickable" id="displayAll" type="checkbox" value="" >
              <label class="form-check-label pointer-clickable" for="displayAll">
                {{ translations('common.display_all') }}
              </label>
            </div>
          </div>
          <div class="form-group ml-2">
            <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{translations('common.search')}}</button>
          </div>
        </div>
        <div class="form-group" style="margin: 1px 0 0 0">
          <button class="btn btn-primary btn-sm" type="button" @click="exportCsv">{{translations('common.csv_export')}}</button>
        </div>
      </div>
      <div class="table-scroll mb-4">

        <v-data-table
          class="table table-striped table-hover table-800 table-clickable"
          item-key="name"
          :headers="[
            { text: 'No', sortable: false },
            { text: this.translations('invoice.payment_day'), value: 'paid_at' },
            { text: this.translations('invoice.supplier'), value: 'younosuke_company_name' },
            { text: this.translations('deposit.name'), value: 'name' },
            { text: this.translations('invoice.deposit_amount'), value: 'total_paid' },
            { text: this.translations('invoice.transfer_fee'), value: 'total_fee' },
            { text: this.translations('invoice.remarks'), value: 'memo' },
          ]"
          :items="payments"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <template v-if="!isEmpty">
                <tr  v-for="(payment, i) in items" :key='i' data-href="" @click="openSinglePayments(payment)">
                  <td>{{i + 1}}</td>
                  <td>{{ $invoiceTools.formatDate(payment.paid_at) }}</td>
                  <td>{{ payment.client_name }}</td>
                  <td>{{ payment.name }}</td>
                  <td class="right">{{ payment.total_paid.toLocaleString() }}</td>
                  <td class="right">{{ payment.total_fee.toLocaleString() }}</td>
                  <td>{{ payment.memo }}</td>
                </tr>
              </template>
              <template v-else>
                <tr class="odd">
                  <td valign="top" colspan="12" class="dataTables_empty">{{ isEmptyMsg }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
    </div>
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
    <ArchivePaymentsModal/>
    <ArchiveBulkPaymentsModal @paid="initList"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import ArchivePaymentsModal from '@/components/ArchivePaymentsModal'
import ArchiveBulkPaymentsModal from '@/components/ArchiveBulkPaymentsModal'
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import Papa from 'papaparse'
import encoding from 'encoding-japanese'

export default {
  name: 'ArchivePayments',
  props: {},
  components: {
    VueElementLoading,
    ArchivePaymentsModal,
    ArchiveBulkPaymentsModal
  },
  computed: {
    ...mapState(['currentLanguage']),
    master_clients () {
      return this.$store.getters['Master/getBillTo']
    }
  },
  data () {
    return {
      dtSearch: '',
      isSearching: false,
      client_id: 0,
      dateFrom: '',
      dateTo: '',
      payments: [],
      isEmpty: false,
      isEmptyMsg: '',
      // tempDateField: '',
      page: 1,
      pageCount: 0,
      totalCount: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      displayAll: false
    }
  },
  watch: {
    // client_id () {
    //   this.initList()
    // },
    page () {
      this.getFilterdList()
    },
    options: {
      handler () {
        let visitCount = Number(localStorage.getItem('visitCountPayments')) || 0
        if (visitCount > 0) {
          this.initList()
        }
      },
      deep: true
    }
  },
  created: async function () {
    this.$store.dispatch('Master/checkBillTo')
    let storedFilter = this.$storage.get('ArchivePaymentsParam')
    if (storedFilter) {
      this.dtSearch = storedFilter.search
      this.client_id = storedFilter.client_id ? parseInt(storedFilter.client_id) : 0
      this.dateFrom = storedFilter.start_at
      this.dateTo = storedFilter.end_at
      this.options.sortBy = storedFilter.orderbys
      this.options.sortDesc = storedFilter.is_descs
    }
  },
  methods: {
    // changeSearch (e) {
    //   console.log(e.target.value)
    //   this.$storage.set('ArchivePayments:dtSearch', e.target.value) // KEEP KEYWORD
    //   this.initList()
    // },
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getFilterTxt (obj, input, output, _default) {
      if (input) {
        if (input === 0) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    // triggerDateFilter (source) {
    //   if (source === 'dateFrom' && this.dateFrom !== this.tempDateField) {
    //     this.initList()
    //   }
    //
    //   if (source === 'dateTo' && this.dateTo !== this.tempDateField) {
    //     this.initList()
    //   }
    // },

    initList () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.getFilterdList()
      }
    },

    getFilterdList () {
      if (this.displayAll) {
        this.$storage.set('payment_display_all', this.displayAll)
        this.options.itemsPerPage = -1 // DISPLAY ALL
      } else {
        this.options.itemsPerPage = 10 // DISPLAY 10 ROWS
      }
      if (this.isSearching) {
        return
      }

      this.isSearching = true

      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      // let search = this.dtSearch
      // if (this.client_id) {
      //   search = ''
      // }
      let params = {
        client_id: this.client_id,
        start_at: this.dateFrom,
        end_at: this.dateTo,
        offset: offset,
        limit: limit,
        orderbys: orderbys,
        is_descs: isDescs,
        search: this.dtSearch
      }
      this.$storage.set('ArchivePaymentsParam', params)
      console.log('ArchivePayments:getFilterdList: ', params)

      return this.$http.post(this.$api_url.payments_list, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.payments = result.list
          localStorage.setItem('visitCountPayments', this.payments.length)
          this.totalCount = Number(result.total_count)
          return Promise.resolve()
        } else {
          this.payments = []
          this.$toastr.error(result.message, this.translations('common.error'))
          return Promise.reject(new Error(result.message))
        }
      }).catch(e => {
        console.log('ArchivePayments:API:getFilterdList: error: ', e)
        this.isEmpty = true
        this.isEmptyMsg = this.translations('deposit.notice_failed')
        return Promise.reject(new Error(this.isEmptyMsg))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    openSinglePayments (payment) {
      this.$router.push({ name: 'single-payments', query: { payments_id: payment.id } })
    },

    changedClients (event) {
      if (!event) {
        this.client_id = 0
        return
      }
      this.client_id = event.id
    },

    submitSearch () {
      this.initList()
    },

    exportCsv () {
      if (this.isSearching) {
        return
      }

      this.isSearching = true

      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      let params = {
        client_id: this.client_id,
        start_at: this.dateFrom,
        end_at: this.dateTo,
        orderbys: orderbys,
        is_descs: isDescs,
        search: this.dtSearch
      }
      console.log('ArchivePayments:exportCsv: ', params)

      return this.$http.post(this.$api_url.payments_csv, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.saveCsv_(result.list)
          return Promise.resolve()
        } else {
          this.payments = []
          this.$toastr.error(result.message, this.translations('common.error'))
          return Promise.reject(new Error(result.message))
        }
      }).catch(e => {
        console.log('ArchivePayments:API:listPayment: error: ', e)
        this.isEmpty = true
        this.isEmptyMsg = this.translations('deposit.notice_failed')
        return Promise.reject(new Error(this.isEmptyMsg))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    saveCsv_ (list) {
      const data = []
      list.forEach(item => {
        data.push([
          item.paid_at,
          item.client_name,
          item.name,
          item.total_paid,
          item.total_fee,
          item.memo
        ])
      })
      let csv = ''
      csv = Papa.unparse({
        fields: [
          this.translations('invoice.payment_day'),
          this.translations('invoice.supplier'),
          this.translations('deposit.name'),
          this.translations('invoice.deposit_amount'),
          this.translations('invoice.transfer_fee'),
          this.translations('invoice.remarks')
        ],
        data: data
      })

      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv' })
      const d = new Date()
      const filename = this.translations('deposit.deposit_') + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'
      saveAs(content, filename)
      this.isLoading = false
    }
  }
}
</script>

<style>
#tbl-payments_wrapper .col-sm-12{
  padding-right: 0 !important;
}
</style>
